import { StorageLocation } from '../types/storageLocation.ts';
import { ShouldBeInventory } from '../types/form/shiftChangeInventoryForm.ts';

interface ShouldBeInventorySlice {
    shouldBeInventory: {
        storageLocation: StorageLocation;
        inventory: ShouldBeInventory['inventory'];
    };
    setShouldBeInventory: (data: Partial<ShouldBeInventory>) => void;
    resetShouldBeInventory: () => void;
}

const createShouldBeInventorySlice = (set: any) => ({
    shouldBeInventory: {
        storageLocation: {} as StorageLocation,
        inventory: [] as ShouldBeInventory['inventory'],
    },

    setShouldBeInventory: (data: Partial<ShouldBeInventory>) =>
        set((state) => ({
            shouldBeInventory: {
                ...state.shouldBeInventory,
                ...data,
            },
        })),

    resetShouldBeInventory: () =>
        set({
            shouldBeInventory: {
                storageLocation: {} as StorageLocation,
                inventory: [] as ShouldBeInventory['inventory'],
            },
        }),
});

export { createShouldBeInventorySlice };
export type { ShouldBeInventorySlice };
